<template>
  <h1>History</h1>
  <div class="accordion" id="yearsAccordion">
    <div v-for="(months, year) in years" :key="year">
      <div class="accordion-item mb-2">
        <h2 class="accordion-header">
          <button
            class="accordion-button fw-bold text-secondary"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="`#year-${year}`"
            aria-expanded="false"
            :aria-controls="`year-${year}`"
          >
            <span class="fs-5">{{ year }}</span>
          </button>
        </h2>
        <div
          :id="`year-${year}`"
          class="accordion-collapse collapse show"
          data-bs-parent="#yearsAccordion"
        >
          <div class="accordion-body">
            <div class="row">
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-2"
                v-for="month in years[year]"
                :key="month"
              >
                <router-link
                  :to="{ name: 'month', params: { month: month } }"
                  class="btn btn-secondary w-100 text-start mb-2"
                  >{{ formatMonth(month) }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.accordion-button {
  width: 100%;
  border: none;
  border-radius: 0;
}
</style>

<script>
// @ is an alias to /src
import router from "@/router";
import { server, formatMonth } from "@/utils/helper";
import axios from "axios";

export default {
  data() {
    return {
      months: [],
      formattedMonths: [],
      years: null,
    };
  },
  async created() {
    await this.fetchMonths();
    this.sortIntoYears();
  },
  methods: {
    formatMonth,
    async fetchMonths() {
      const bearerToken = localStorage.getItem("jwt");
      await axios
        .get(`${server.baseUrl}/months`, {
          headers: { Authorization: "Bearer " + bearerToken },
          redact: ["authorization"],
        })
        .then((data) => {
          this.months = data.data;
        })
        .catch((error) => {
          console.log("Error caught");
          if (error.response.status == 401) {
            router.push("/login");
          }
        });
    },
    sortIntoYears() {
      console.log(this.months);
      this.years = this.months.reduce((map, month) => {
        const year = month.month.split("-")[0];
        if (!map[year]) {
          map[year] = [];
        }
        map[year].push(month.month);
        console.log(map);
        return map;
      }, {});
    },
  },
};
</script>
